 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"GamePayRedirect":"GamePayRedirect","Home":"Home","NoLogin":"NoLogin","Feedback":"Feedback","ActivityCenter~GameIntroduce~Group~NewReservation":"ActivityCenter~GameIntroduce~Group~NewReservation","ActivityCenter~AnswerInvite":"ActivityCenter~AnswerInvite","ActivityCenter":"ActivityCenter","AnswerDetail~AnswerInvite~FaceToFace~PostDetail~PostVideo~QuestionDetail":"AnswerDetail~AnswerInvite~FaceToFace~PostDetail~PostVideo~QuestionDetail","AnswerInvite":"AnswerInvite","AnswerDetail~FaceToFace~GameIntroduce~Group~LotteryRecord~NewReservation~NotFound~PostDetail~PostVid~b637cb5f":"AnswerDetail~FaceToFace~GameIntroduce~Group~LotteryRecord~NewReservation~NotFound~PostDetail~PostVid~b637cb5f","GameIntroduce":"GameIntroduce","Group":"Group","NewReservation":"NewReservation","AnswerDetail~PostDetail~PostVideo~QuestionDetail":"AnswerDetail~PostDetail~PostVideo~QuestionDetail","AnswerDetail":"AnswerDetail","PostDetail":"PostDetail","PostVideo":"PostVideo","QuestionDetail":"QuestionDetail","FaceToFace":"FaceToFace","LotteryRecord":"LotteryRecord","NotFound":"NotFound","BindPhone~Logoff":"BindPhone~Logoff","BindPhone":"BindPhone","Logoff":"Logoff","CommonError":"CommonError"}[chunkId]||chunkId) + "." + {"GamePayRedirect":"5d25330a","Home":"75df4c45","NoLogin":"195e9cd4","chunk-04771816":"24c5d1f5","chunk-44ec9264":"cc4a0094","Feedback":"131a61f2","chunk-756922b8":"2e1de39b","ActivityCenter~GameIntroduce~Group~NewReservation":"b2538422","chunk-0d5cf321":"8e7d22ce","ActivityCenter~AnswerInvite":"9e20c5ed","ActivityCenter":"452a8f23","AnswerDetail~AnswerInvite~FaceToFace~PostDetail~PostVideo~QuestionDetail":"994ca5aa","AnswerInvite":"7759fec6","AnswerDetail~FaceToFace~GameIntroduce~Group~LotteryRecord~NewReservation~NotFound~PostDetail~PostVid~b637cb5f":"2447b117","GameIntroduce":"a42548dd","Group":"d7edac7f","NewReservation":"1a376f57","AnswerDetail~PostDetail~PostVideo~QuestionDetail":"5ba72c40","AnswerDetail":"2e05359e","PostDetail":"063db41b","PostVideo":"1113fae3","QuestionDetail":"9f699f64","FaceToFace":"1a7bbc96","LotteryRecord":"82fb77f8","NotFound":"49f1bb12","BindPhone~Logoff":"040e2de5","BindPhone":"4d9440b9","Logoff":"5ad9401f","CommonError":"b759031a","chunk-3df910a8":"15e706d8","chunk-78c6ca6b":"57f7f4b8","chunk-3698cd2f":"4d04f05d","chunk-028abf42":"91bc6e2e","chunk-8f62daf6":"de97ee53","chunk-9d19d694":"e63b7144","chunk-49320140":"eb42e13a","chunk-1426f7be":"890a5e05","chunk-38bd86aa":"f7526226","chunk-5b437b99":"341dce57","chunk-8921046e":"18def5e1","chunk-09a73d55":"587c80bb","chunk-3d0b0c5d":"c499df44","chunk-40354649":"351ac257","chunk-013860ba":"cb41b1a8","chunk-14565c8f":"a5af7fe9","chunk-2d213ddc":"2add3736","chunk-a9fadd9e":"47a40559"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"GamePayRedirect":1,"Feedback":1,"chunk-756922b8":1,"chunk-0d5cf321":1,"ActivityCenter~AnswerInvite":1,"ActivityCenter":1,"AnswerDetail~AnswerInvite~FaceToFace~PostDetail~PostVideo~QuestionDetail":1,"AnswerInvite":1,"AnswerDetail~FaceToFace~GameIntroduce~Group~LotteryRecord~NewReservation~NotFound~PostDetail~PostVid~b637cb5f":1,"GameIntroduce":1,"Group":1,"NewReservation":1,"AnswerDetail~PostDetail~PostVideo~QuestionDetail":1,"AnswerDetail":1,"PostDetail":1,"PostVideo":1,"QuestionDetail":1,"FaceToFace":1,"LotteryRecord":1,"NotFound":1,"BindPhone~Logoff":1,"BindPhone":1,"Logoff":1,"CommonError":1,"chunk-3df910a8":1,"chunk-78c6ca6b":1,"chunk-3698cd2f":1,"chunk-028abf42":1,"chunk-8f62daf6":1,"chunk-9d19d694":1,"chunk-49320140":1,"chunk-1426f7be":1,"chunk-38bd86aa":1,"chunk-5b437b99":1,"chunk-8921046e":1,"chunk-09a73d55":1,"chunk-3d0b0c5d":1,"chunk-40354649":1,"chunk-013860ba":1,"chunk-14565c8f":1,"chunk-a9fadd9e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"GamePayRedirect":"GamePayRedirect","Home":"Home","NoLogin":"NoLogin","Feedback":"Feedback","ActivityCenter~GameIntroduce~Group~NewReservation":"ActivityCenter~GameIntroduce~Group~NewReservation","ActivityCenter~AnswerInvite":"ActivityCenter~AnswerInvite","ActivityCenter":"ActivityCenter","AnswerDetail~AnswerInvite~FaceToFace~PostDetail~PostVideo~QuestionDetail":"AnswerDetail~AnswerInvite~FaceToFace~PostDetail~PostVideo~QuestionDetail","AnswerInvite":"AnswerInvite","AnswerDetail~FaceToFace~GameIntroduce~Group~LotteryRecord~NewReservation~NotFound~PostDetail~PostVid~b637cb5f":"AnswerDetail~FaceToFace~GameIntroduce~Group~LotteryRecord~NewReservation~NotFound~PostDetail~PostVid~b637cb5f","GameIntroduce":"GameIntroduce","Group":"Group","NewReservation":"NewReservation","AnswerDetail~PostDetail~PostVideo~QuestionDetail":"AnswerDetail~PostDetail~PostVideo~QuestionDetail","AnswerDetail":"AnswerDetail","PostDetail":"PostDetail","PostVideo":"PostVideo","QuestionDetail":"QuestionDetail","FaceToFace":"FaceToFace","LotteryRecord":"LotteryRecord","NotFound":"NotFound","BindPhone~Logoff":"BindPhone~Logoff","BindPhone":"BindPhone","Logoff":"Logoff","CommonError":"CommonError"}[chunkId]||chunkId) + "." + {"GamePayRedirect":"6356b666","Home":"31d6cfe0","NoLogin":"31d6cfe0","chunk-04771816":"31d6cfe0","chunk-44ec9264":"31d6cfe0","Feedback":"6d0b7090","chunk-756922b8":"64b343ab","ActivityCenter~GameIntroduce~Group~NewReservation":"31d6cfe0","chunk-0d5cf321":"c412edf5","ActivityCenter~AnswerInvite":"e0c9ea2c","ActivityCenter":"296c9dd1","AnswerDetail~AnswerInvite~FaceToFace~PostDetail~PostVideo~QuestionDetail":"36c80cbd","AnswerInvite":"863f9c29","AnswerDetail~FaceToFace~GameIntroduce~Group~LotteryRecord~NewReservation~NotFound~PostDetail~PostVid~b637cb5f":"30bd7a1a","GameIntroduce":"ef873cd9","Group":"733133a7","NewReservation":"bdea3d9f","AnswerDetail~PostDetail~PostVideo~QuestionDetail":"00b0ec63","AnswerDetail":"48668e4e","PostDetail":"f4656f13","PostVideo":"d32b9c7f","QuestionDetail":"2792b793","FaceToFace":"cdbcc9cc","LotteryRecord":"6f66f8ee","NotFound":"9bca9d42","BindPhone~Logoff":"61409bba","BindPhone":"2e3407e4","Logoff":"9bee95ae","CommonError":"82ae7cae","chunk-3df910a8":"0ba33b6e","chunk-78c6ca6b":"973c5200","chunk-3698cd2f":"67ec0133","chunk-028abf42":"ce027fd2","chunk-8f62daf6":"4314a2de","chunk-9d19d694":"52a9e2ce","chunk-49320140":"27c6760b","chunk-1426f7be":"33e036d8","chunk-38bd86aa":"1e1fae55","chunk-5b437b99":"a9ae255b","chunk-8921046e":"c5d9cc51","chunk-09a73d55":"0597c10b","chunk-3d0b0c5d":"0aa20705","chunk-40354649":"e5458e6f","chunk-013860ba":"91ed626d","chunk-14565c8f":"eb408b63","chunk-2d213ddc":"31d6cfe0","chunk-a9fadd9e":"315916f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//static.gameplus.qq.com/wap/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
